import React, { FC } from 'react';

const RestaurantIcon: FC = () => {
    return (
        <svg
            className="svg-inline"
            viewBox="0 0 26 26"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3.9082 21.9336H22.7138" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M3.9082 7.37533V8.43694C3.9082 9.28161 4.23842 10.0917 4.82621 10.6889C5.414 11.2862 6.21121 11.6218 7.04247 11.6218C7.87373 11.6218 8.67094 11.2862 9.25873 10.6889C10.1748 9.75812 10.1767 8.59246 10.1767 7.37533M3.9082 7.37533H10.1767M3.9082 7.37533L5.99771 3.12891H20.6243L22.7138 7.37533M3.9082 7.37533H13.311H22.7138M10.1767 7.37533V8.43694C10.1767 9.28161 10.507 10.0917 11.0947 10.6889C11.6825 11.2862 12.4797 11.6218 13.311 11.6218C14.1423 11.6218 14.9395 11.2862 15.5273 10.6889C16.1151 10.0917 16.4453 9.28161 16.4453 8.43694M16.4453 8.43694V7.37533M16.4453 8.43694C16.4453 9.28161 16.7755 10.0917 17.3633 10.6889C17.9511 11.2862 18.7483 11.6218 19.5795 11.6218C20.4108 11.6218 21.208 11.2862 21.7958 10.6889C22.3836 10.0917 22.7138 9.28161 22.7138 8.43694V7.37533"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6.33398 21.9338V11.6211" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.2871 21.9338V11.6211" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M9.97461 21.9355V17.8912C9.97461 17.355 10.209 16.8406 10.6261 16.4614C11.0432 16.0822 11.609 15.8691 12.1989 15.8691H14.4232C15.0132 15.8691 15.5789 16.0822 15.9961 16.4614C16.4132 16.8406 16.6476 17.355 16.6476 17.8912V21.9355"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default RestaurantIcon;
